import { useState, useEffect, useCallback, useRef } from 'react';
import { Button } from 'rsuite';
import { EXAMINATION_VIDEO_BASE_URL, IMAGE_BASE_URL, postSaveDiagnosis } from '../../../core';
import TurnBackIcon from '../../../assets/icons/turn_back.svg';
// import { CustomLoader } from './../../../components/basic/loader';
import { useNavigate } from 'react-router-dom';
import { CustomLoader } from '../../../components/basic/loader';
import { showToast } from '../../../utils/toast';
// import { showToast } from '../../../utils/toast';
// import { showToast } from '../../../utils/toast';
import ReactPlayer from 'react-player';
import { useDiagnosis } from '../../../contexts/diagnosis';
interface QuestionModel {
  question_id: number;
  question_title: string;
  question_explain_text: string;
  question_explain_voice_address: string;
  question_explain_image: string;
}
interface OptionsModel {
  related_question_id: number;
  option_title: string;
  option_value: number;
}
export const ScoreAlg = (props: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: { questions: any[]; options: any[]; results: any[] } | any;
  productId: number;
  invoiceId: number;
  refNumber: string;
  viewMode?: boolean;
}) => {
  const navigate = useNavigate();
  const { setShowModal } = useDiagnosis();

  const [playingAudio, setPlayingAudio] = useState('');
  const [questions, setQuestions] = useState(props.data?.questions); //vertices
  const [options, setOptions] = useState(props.data?.options); //edges
  const [results, setResults] = useState(props.data?.results); //results
  const [log, setLog] = useState<QuestionModel[]>([]);
  const [answersLog, setAnswersLog] = useState<string[]>([]);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [pathOfEdges, setPathOfEdges] = useState<any[]>([]);
  const [currentQuestionId, setCurrentQuestionId] = useState(1);
  const [fakeLoading, setFakeLoading] = useState(false);
  const [isDone, setIsDone] = useState(false);

  const chatParent = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (props.viewMode) {
      console.log('asasasd', props.data);
      if (props.data?.path_of_diagnosis_edges && props.data?.path_of_diagnosis_vertices) {
        const tempAnswersLog: string[] = [];
        setPathOfEdges(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          JSON.parse(props.data.path_of_diagnosis_edges).map((item: any, index: number) => {
            const parsed = JSON.parse(item);
            console.log(parsed);
            tempAnswersLog[index] = parsed.option_title; //
            return parsed;
          })
        );

        setAnswersLog(tempAnswersLog);
        setLog(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          JSON.parse(props.data.path_of_diagnosis_vertices).map((item: any) => JSON.parse(item))
        );
        console.log(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          JSON.parse(props.data.path_of_diagnosis_vertices).map((item: any) => JSON.parse(item))
        );
      }
      setShowModal(false);
      setIsDone(true);
      return;
    }
    setOptions(props.data.options);
    setQuestions(props.data.questions);
    setResults(props.data.results);
    setLog([props.data.questions[0]]);
    setAnswersLog([]);
    setCurrentQuestionId(1);
    setIsDone(false);
    // console.log(props.data.edges[0]);
  }, [
    props.data?.options,
    props.data?.questions,
    props.data?.results,
    props?.viewMode,
    props.data,
    props
  ]);

  const handleMoveToNextQuestion = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (nextQuestionId: number, toQuestion: QuestionModel, clickedLabel: string, edge: any) => {
      setFakeLoading(true);
      setPlayingAudio('');
      setTimeout(() => {
        if (nextQuestionId === questions[questions.length - 1].question_id) {
          console.log('asdasdsa');
          setShowModal(false);
          setIsDone(true);
        } else {
          setLog((prev) => [...prev, toQuestion]);
        }
        setCurrentQuestionId(nextQuestionId);
        setAnswersLog((prev) => [...prev, clickedLabel]);
        setPathOfEdges((prev) => [...prev, edge]);
        setFakeLoading(false);
      }, 500);
    },
    [currentQuestionId, questions]
  );
  const handleMoveToPevQuestion = useCallback(() => {
    const last = log.length - 1;
    setCurrentQuestionId(last);
    setAnswersLog((prev) => prev.slice(0, -1));
    setPathOfEdges((prev) => prev.slice(0, -1));
    setLog((prev) => prev.slice(0, -1));
  }, [log]);

  useEffect(() => {
    const domNode = chatParent.current;
    if (domNode) {
      domNode.scroll({ top: domNode.scrollHeight + 200, behavior: 'smooth' });
    }
  }, [log]);

  const calculateScore = useCallback(() => {
    const score = pathOfEdges.reduce((sum, tax) => {
      return sum + tax.option_value;
    }, 0);

    for (const res of results) {
      console.log(res.max_value, res.min_value);
      if (res.min_value <= score && score <= res.max_value) {
        console.log(score, res.min_value, res.max_value, res.result_explain);
        return {
          question_explain_image: '',
          question_explain_text: '',
          question_id: log[log.length - 1].question_id + 1,
          question_title: res.result_explain
        };
      }
    }
    console.log('not found');
    console.log(score, results);
    return {
      question_explain_image: '',
      question_explain_text: '',
      question_id: log[log.length - 1].question_id + 1,
      question_title: ''
    };
  }, [log, pathOfEdges, props.data?.results]);
  const handleShowSuggested = useCallback(() => {
    // doctor_suggestion
    navigate(`/suggestions/${props.productId}/${log[log.length - 1].question_id}/`);
  }, [props.productId, log]);

  useEffect(() => {
    if (props.viewMode) return;
    if (!isDone) return;
    // todo
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const res: any = calculateScore();
    setLog((prev) => [...prev, res]);
    const logsCopy = [...log, res];
    console.log(logsCopy, pathOfEdges);
    const payload = {
      end_result_vertex: JSON.stringify({
        questionLabel: res.question_title,
        vertexId: res.question_id
      }),
      product_id: props.productId,
      path_of_diagnosis_vertices: JSON.stringify(logsCopy.map((item) => JSON.stringify(item))),
      path_of_diagnosis_edges: JSON.stringify(pathOfEdges.map((item) => JSON.stringify(item))),
      invoice_id: props.invoiceId,
      ref_num: props.refNumber
    };
    console.log(payload);
    (async () => {
      try {
        const { data, status } = await postSaveDiagnosis(payload);
        console.log(data);
        if (status) {
          showToast('با موفقیت ثبت شد!', 'success');
        }
      } catch (e) {
        console.log(e);
      }
    })();
  }, [isDone, props.viewMode]);

  if (!props.viewMode && (!questions?.length || !options?.length)) {
    return <CustomLoader />;
  }

  return (
    <div className="h-[100%] bg-[#fff] pt-3">
      <div className={`${isDone ? 'h-[87%]' : 'h-[70%]'} overflow-auto px-3`} ref={chatParent}>
        {!isDone ? <p className="text-center mb-2">به سوالات با دقت و حوصله پاسخ دهید</p> : null}
        {log?.map((item, index) => {
          return (
            <div key={item.question_id}>
              <div
                className="max-w-[95%] w-fit mr-auto bg-[#47e49a] p-3 text-[--rs-gray-800] text-justify mb-2"
                style={{ borderRadius: '20px 20px 20px 0' }}>
                {item.question_title}
              </div>
              {item.question_explain_text ? (
                <div
                  className="max-w-[95%] w-fit mr-auto bg-[#47e49a] p-3 text-[--rs-gray-800] text-justify mb-2"
                  style={{ borderRadius: '20px 20px 20px 0' }}>
                  {item.question_explain_text}
                </div>
              ) : null}
              {item.question_explain_voice_address ? (
                <ReactPlayer
                  className="max-w-[100%] custom-video mb-2"
                  url={`${EXAMINATION_VIDEO_BASE_URL}/${item.question_explain_voice_address}`}
                  controls
                  playing={item.question_explain_voice_address === playingAudio}
                  onPlay={() => {
                    setPlayingAudio(item.question_explain_voice_address ?? '');
                  }}
                  config={{
                    file: {
                      attributes: {
                        controlsList: 'nodownload'
                      }
                    }
                  }}
                />
              ) : null}
              {item.question_explain_image ? (
                <img
                  style={{ width: '100%', marginBottom: '8px' }}
                  src={`${IMAGE_BASE_URL}/${item.question_explain_image}`}
                />
              ) : null}
              {answersLog[index] ? (
                <div
                  className="max-w-[95%] w-fit ml-auto bg-[--rs-gray-400] p-3 text-[--rs-gray-100] text-justify mb-2"
                  style={{ borderRadius: '20px 20px 0 20px' }}>
                  {answersLog[index]}
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
      {props.viewMode ? null : (
        <div className="max-h-[20%] px-3 flex flex-col items-center justify-between overflow-auto pt-2">
          {!isDone &&
            options[currentQuestionId]?.map((option: OptionsModel) => {
              return (
                <Button
                  appearance="primary"
                  className="!mb-2 inline-block !px-1 w-[90%] min-h-[48px]"
                  style={{ whiteSpace: 'pre-wrap' }}
                  key={`${option.related_question_id} ${option.option_value}`}
                  onClick={() => {
                    handleMoveToNextQuestion(
                      option.related_question_id,
                      questions[option.related_question_id],
                      option.option_title,
                      option
                    );
                  }}
                  loading={fakeLoading}>
                  {option.option_title}
                </Button>
              );
            })}
        </div>
      )}
      <div className="px-3 flex flex-row-reverse">
        {currentQuestionId > 1 && !isDone ? (
          <Button
            onClick={() => {
              setPlayingAudio('');
              handleMoveToPevQuestion();
            }}
            // loading={fakeLoading}
            size="md"
            className="btn-outline">
            <img
              src={TurnBackIcon}
              className="ml-2 w-4"
              style={{ transform: 'rotateY(180deg)' }}
              alt=""
            />
            سوال قبل
          </Button>
        ) : null}
      </div>
      <div className="px-3 flex justify-center py-1">
        {isDone ? (
          <Button appearance="primary" onClick={() => handleShowSuggested()} loading={fakeLoading}>
            پیشنهاد پزشک متخصص جهت ویزیت حضوری
          </Button>
        ) : null}
      </div>
    </div>
  );
};
